<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Przepięcia polis'" [name]="'Importuj'"></app-breadcrumb>
<div class="commission-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="commissionRedirectionImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-md="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/csv"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="commissionRedirectionImportForm.get('fileContent').hasError('backendError')">
            {{commissionRedirectionImportForm.get('fileContent').getError('backendError')}}
          </mat-error>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="true"
            ></app-dict>
          </div>

          <div fxLayout="row">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="true"
              [control]="insuranceCompanyControl"
              [companyId]="importCompanyId"
              (selectedInsuranceCompany)="selectedInsuranceCompany = $event; loadIdDict();"
              [hideChildren]="true"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row">
            <app-detail
              header="Dostępne identyfikatory"
              fxFlex="100"
            >
              <mat-chip-list>
                <mat-chip color="accent" selected>
                  Login Hiperio
                </mat-chip>
                <mat-chip color="accent" selected>
                  Login Chronie.pl
                </mat-chip>
                <mat-chip color="accent" selected>
                  RAU
                </mat-chip>
                <mat-chip color="accent" selected>
                  PESEL
                </mat-chip>

                <ng-container *ngFor="let id of registrationIdTypes">
                  <mat-chip color="accent" selected>
                    {{id.name}}
                  </mat-chip>
                </ng-container>
              </mat-chip-list>

            </app-detail>
          </div>
        </mat-card>
      </div>
    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!commissionRedirectionImportFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
    <a href="/rest/crm/static/doc/Szablon_importu_przepiec.xlsx" target="_blank" mat-stroked-button color="primary">
      <mat-icon>download</mat-icon> Szablon importu
    </a>
  </div>
</div>
